module.exports = __webpack_public_path__ + "static/media/C3_mid_long_44.1k.07d4d97c.mp3";